angular.module('mymessages').controller('MyMessagesCtrl',
    ['$scope', '$location', '$state', 'ContentAttributeService',
        function ($scope, $location, $state, ContentAttributeService) {
            'use strict';

            $scope.loading = true;

            $scope.model = {
                subMessageText: ''
            };

            $scope.messageLinkSelected = function(linkId) {
                if (linkId === 'messages-inbox-btn') {
                    if ($location.path() === '/my-messages/display-messages/received') {
                        $state.reload();
                    }
                } else if (linkId === 'messages-sent-btn') {
                    //$scope.myMessages.DisplayCriteriaMenu = false;
                }
            };

            function getMessageSubHeading() {
                ContentAttributeService.getMessageSubHeading(false)
                    .then(function(data) {
                        $scope.model.subMessageText = data;
                    })
                    .catch(function () {
                        $scope.model.subMessageText = '';
                    });
            }

            function onLoad() {
                getMessageSubHeading();
            }
            onLoad();

            $scope.loading = false;
        }]);